module.exports = __webpack_public_path__ + "img/nordaxbank.74b1ce2.png";